import { render, staticRenderFns } from "./CardModalSidebarActions.vue?vue&type=template&id=34675374&scoped=true"
import script from "./CardModalSidebarActions.vue?vue&type=script&lang=js"
export * from "./CardModalSidebarActions.vue?vue&type=script&lang=js"
import style0 from "./CardModalSidebarActions.vue?vue&type=style&index=0&id=34675374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34675374",
  null
  
)

export default component.exports